import { Component } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { interval, map, shareReplay, startWith } from 'rxjs';
import { AsyncPipe, DatePipe } from '@angular/common';
import { ProductInformationTestIds } from './sb-product-information.test-ids';

@Component({
  selector: 'app-sb-product-information',
  imports: [AsyncPipe, DatePipe],
  templateUrl: './sb-product-information.component.html',
  styleUrl: './sb-product-information.component.scss'
})
export class SbProductInformationComponent {
  protected readonly testIds = ProductInformationTestIds;
  productId = environment.productId;
  productType = environment.productType;
  applicationName = environment.applicationName;
  productTypeVersion = environment.productTypeVersion;
  producerId = environment.producerId;
  productShortname = environment.productShortname;
  productVersion = environment.productVersion;
  producerName = environment.producerName;
  productName = environment.productName;

  readonly time$ = interval(1000).pipe(
    startWith(0),
    map(() => new Date()),
    shareReplay({ bufferSize: 1, refCount: true })
  );
}
